import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import Api from '../../../../../helpers/api';
import { t } from '../../../../../i18n';

const api = new Api('companies/:company_id');
const formDataApi = new Api('companies/:id/talent_conversion_rule');

function* edit({ payload }) {
  try {
    const { company_id } = payload;
    const result = yield call(sendRequest, api.load, { id: company_id }, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;
      const { talent_conversion_rule } = data;

      yield put(actions.editSuccess({ talent_conversion_rule }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* update({ payload }) {
  try {
    const { editForm, company_id } = payload;

    const data = {
      company: {
        talent_conversion_rule_attributes: {
          minimum_threshold: editForm.minimum_threshold.value,
          exempted_unit_ids:
            editForm.unit_exemption && editForm.unit_exemption.value
              ? editForm.exempted_units.value.map(item => item.value)
              : [],
        },
      },
    };

    const result = yield call(
      sendRequest,
      api.multiparamsUpdateItem,
      { data, params: { company_id } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', {
            item: t('dash.companies.company.talent_conversion_rules_title'),
          }),
        }),
      );
      yield put(actions.updateSuccess());
      yield put(push(`/companies/${company_id}?tab=talent-conversion-rule`));
    } else {
      yield put(actions.saveError({ data: result.talent_conversion_rule }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData({ payload }) {
  try {
    const { company_id } = payload;
    const result = yield call(sendRequest, formDataApi.loadFormData, { id: company_id }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data && result.data.success.data.units) {
      const { units } = result.data.success.data;

      yield put(actions.loadFormDataSuccess({ units }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.EDIT, edit), takeEvery(actions.EDIT, loadFormData), takeEvery(actions.UPDATE, update)]);
}
